<template>
  <div :class="`modal modal-${type}`">

    <transition name="modal-overlay" @after-leave="count++;">
      <div v-if="show" class="modal-overlay" @click="handleClickOverlay"></div>
    </transition>

    <div class="modal-container" :class="[{'bg-white': type === 'full' && !containerClass}, containerClass]">

      <transition v-if="type !== 'full'" name="modal-close" @after-leave="count++;">
        <button v-if="show"
                @click="handleClickClose"
                class="modal-close pin-r pin-t absolute z-10 p-2 text-gray-light hover:text-gray-dark">
          <svgicon name="close"/>
        </button>
      </transition>

      <transition :name="type === 'full' ? 'modal-full-content' : 'modal-content'" @after-leave="count++;">
        <div v-if="show" class="modal-content">
          <div class="container mx-auto p-4 lg:p-8">
            <slot></slot>
          </div>
        </div>
      </transition>

    </div>

    <transition v-if="type === 'full'" name="modal-close" @after-leave="count++;">
      <vue-button v-if="show"
                  class="modal-close btn btn-gray btn-outline rounded-full fixed pin-t pin-r m-4"
                  icon-class="svg-md"
                  icon="close"
                  @click="handleClickClose"/>
    </transition>

  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'full',
    },
    active: {
      type: Boolean,
      default: false,
    },
    containerClass: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      show: false,
      count: 0,
    };
  },

  mounted() {
    this.show = this.active;
  },

  watch: {
    count() {
      if (this.count >= 3) {
        this.$emit('closed');
      }
    },
    active(value) {
      this.show = value;
    },
  },

  methods: {
    close() {
      this.show = false;
    },

    handleClickOverlay() {
      if (this.type !== 'full') {
        this.close();
      }
    },

    handleClickClose() {
      this.close();
    },
  },
};
</script>